module.exports = __webpack_public_path__ + "img/Anartz_Mugika.cb998c7c.jpg";